import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "../i18n";
import Header from "../components/layout/Header.jsx";
import Footer from "../components/layout/Footer.jsx";
import { AltPathProvider } from "../context/AltPathContext.jsx";

const STORAGE_KEY = "preferredLanguage";

export default function LanguageLayout() {
  const { lang } = useParams();

  if (!SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANGUAGE}/`} replace />;
  }

  // i18next itself is already synced from the URL in App.jsx, before this
  // component even mounts (see the comment there for why it has to happen
  // that early). This effect only owns the two things that are genuinely
  // side effects, not render output: the <html lang> attribute and the
  // persisted language preference.
  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  return (
    <AltPathProvider>
      <Header lang={lang} />
      <main>
        <Outlet />
      </main>
      <Footer lang={lang} />
    </AltPathProvider>
  );
}
